<template>
	<!-- 关于我们 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>
		
		<div class="details">
			<div class="line"></div>
			<div class="details-c">
				<div class="details-c-h">
					产品中心 > 产品详情
				</div>
				<div class="details-c-b">
					<div class="l">
						<svg v-if="list.length > 3" 
							class="l-top" 
							@click="scrollThumbnails('up')" 
							viewBox="0 0 24 24" 
							width="24" 
							height="12">
							<path 
								d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
								fill="#008D8E"
							/>
						</svg>
						<div class="l-middlen-container">
							<div class="thumbnail-wrapper" ref="thumbnailContainer">
								<div class="l-middlen" 
									v-for="(item, index) in list" 
									:key="index"
									@click="selectImage(index)"
									:class="{ active: currentIndex === index }">
									<img :src="item" alt="">
								</div>
							</div>
						</div>
						<svg v-if="list.length > 3" 
							class="l-bottom" 
							@click="scrollThumbnails('down')" 
							viewBox="0 0 24 24" 
							width="24" 
							height="12">
							<path 
								d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
								fill="#008D8E"
							/>
						</svg>
					</div>
					<div class="m">
						<img class="mimg" :src="list[currentIndex]" alt="">
					</div>
					<div class="r">
						<div class="r-top">产品简介</div>
						<div class="r-sec">Product introduction</div>
						<div class="r-sec1">{{info.productName}}</div>
						<div class="r-sec2" v-html="info.productIntroduce"></div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="details-c1">
			<div class="details-c1-1">超能瓦</div>
		</div>
		
		<div class="details-c2">
			<div class="details-c2-1">
				<div class="h">产品参数</div>
				<div class="f">
					<div>外观尺寸：{{info.size}}</div>
					<div>材质：{{info.material}}</div>
					<div>工作电压：105*105*40mm</div>
					<div>工作温度：{{info.temperature}} <span style="margin-left:20px">相对湿度{{info.humidity}}</span></div>
				</div>
				
			</div>
		</div>
		

		<footer1></footer1>
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import {
	  productdetails
	} from '@/api/home.js';
	import mobilemenu from "@/components/mobile-menu.vue";
	import header1 from "@/components/header.vue";
	
	import footer1 from "@/components/footer.vue";
	export default {
		components: {
			header1,
			footer1,
			mobilemenu
			
		},
		data() {
			return {
				pathname: "product",
				menutitle:"产品中心",
				navList:["智能产品", "智能制造"],
				selectIndex:0,
				isShowMobile:false,
				info:{},
				list: [],
				currentIndex: 0,
				scrollPosition: 0,
				thumbnailHeight: 80,
				visibleThumbnails: 3
			}
		},
		computed: {
			currentImage() {
				return this.list[this.currentIndex] || ''
			}
		},
		created() {
			this.getproductdetails()
		},
		methods: {
			getproductdetails() {
				productdetails({
					id:this.$route.query.id
				}).then(res => {
					console.log(res.data.data)
					this.info = res.data.data
					let list = res.data.data.profile.split(",")
					this.list=[...list]
				
				})
			},
			tapMenu(e) {
				this.selectIndex = e
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			},
			selectImage(index) {
				this.currentIndex = index
			},
			scrollThumbnails(direction) {
				const container = this.$refs.thumbnailContainer
				const maxScroll = (this.list.length - this.visibleThumbnails) * (this.thumbnailHeight + 32)
				
				if (direction === 'up') {
					this.scrollPosition = Math.max(this.scrollPosition - (this.thumbnailHeight + 32), 0)
				} else {
					this.scrollPosition = Math.min(this.scrollPosition + (this.thumbnailHeight + 32), maxScroll)
				}
				
				container.style.transform = `translate3d(0, -${this.scrollPosition}px, 0)`
			}
		}
	}
</script>

<style lang="scss">
	.content1 {
		padding-top: 100px;
		img {

		}

		.details {
			width: 100%;
			height: 596px;
			background-color: #F3F9F9;
			display: flex;
			justify-content: center;
			position: relative;
			.line {
				position: absolute;
				top: 60px;
				left: 0;
				width: 100%;
				height: 1px;
				background-color: #eee;
				z-index: 2;
			}  
			.details-c {
				width: 1200px;
				.details-c-h {
					height: 60px;
					font-size: 16px;
					color: #999999;
					line-height: 60px;
				}
				.details-c-b {
					height: 535px;
					padding: 70px 0 ;
					display: flex;
					justify-content: space-between;
					align-items: center;
					.l {
						width: 80px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						position: relative;
						height: 400px;
						
						.l-top, .l-bottom {
							width: 24px;
							height: 12px;
							cursor: pointer;
							z-index: 2;
							transition: all 0.3s ease;
							
							&:hover {
								opacity: 0.8;
								transform: scale(1.1);
							}
							
							&:active {
								transform: scale(0.95);
							}
						}
						
						.l-top {
							margin-bottom: 8px;
						}
						
						.l-bottom {
							margin-top: 8px;
						}
						
						.l-middlen-container {
							height: 324px;
							width: 90px;
							overflow: hidden;
							position: relative;
							
							.thumbnail-wrapper {
								position: absolute;
								left: 0;
								top: 0;
								width: 100%;
								transition: transform 0.3s ease;
							}
						}
						
						.l-middlen {
							width: 80px;
							height: 80px;
							margin: 16px 0;
							cursor: pointer;
							border: 2px solid transparent;
							
							&.active {
								border-color: #008D8E;
							}
							
							img {
								width: 76px;
								height: 76px;
								object-fit: cover;
							}
						}
					}
					.m {
						width: 990px;
						display: flex;
						justify-content: center;
						align-items: center;
						.mimg {
							width: 420px;
							height: 300px;
							object-fit: contain;
						}
					}
					.r {
						width: 520px;
						height: 413px;
						background-color: white;
						padding: 48px 56px;
						.r-top {
							font-size: 30px;
							color: #332C2B;
						}
						.r-sec {
							margin-top: 8px;
							font-size: 18px;
							color: #332C2B;
						}
						.r-sec1 {
							margin-top: 30px;
							font-size: 18px;
							color: #332C2B;
						}
						.r-sec2 {
							margin-top: 16px;
							font-size: 14px;
							color: #666666;
						}
					}
				}
			}
			
		}
        
		.details-c1 {
			width: 100%;
			height: 105px;
			background-color: #008D8E;
			display: flex;
			justify-content: center;
			.details-c1-1 {
				width: 1200px;
				font-size: 24px;
				color: #FFFFFF;
				line-height: 105px;
			}
		}
		.details-c2 {
			width: 100%;
			background-color: #fff;
			display: flex;
			justify-content: center;
			padding: 30px 0 80px;
			.details-c2-1 {
				width: 1200px;
				font-size: 24px;
				color: #FFFFFF;
				line-height: 105px;
				.h {
					width: 80px;
					height: 72px;
					line-height: 72px;
					font-size: 20px;
					color: #332C2B;
					border-bottom: 2px solid #008D8E;
				}
				.f {
					width: 100%;
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-size: 18px;
					color: #666666;
					flex-wrap: wrap;
					background-color: #f5f5f5;
					padding: 1px;
					div {
						width: calc(50% - 0.5px);
						height: 80px;
						line-height: 80px;
						margin-bottom: 1px;
						padding: 0 40px;
						background-color: #fff;
					}
				}
			}
		}

	}
</style>
